/**
 * The one slice of `prefsStore`'s persisted shape that `src/i18n` also
 * needs, read independently so i18next can pick its initial language at
 * module load — synchronously, before the first render, the same way
 * `prefsStore`'s own `load()` reads this key. `prefsStore` stays the only
 * place that reads or writes the rest of what's stored here.
 */
export const PREFS_STORAGE_KEY = 'shadowtooti.prefs'

export function readStoredLanguage() {
  try {
    const stored = JSON.parse(localStorage.getItem(PREFS_STORAGE_KEY) ?? 'null')
    return stored?.language === 'en' ? 'en' : 'fa'
  } catch {
    // No storage (a private window, the unit environment): Persian, like every other first run.
    return 'fa'
  }
}
